import { useSiteInfo } from '@contexts/SiteInfoContext';
import { useTranslation } from 'next-i18next';
import { useContext, useEffect } from 'react';
import { HeaderContext } from '@contexts/HeaderContext';
import { setCookie, delCookie } from '@utils/cookieUtils';
import ServerPath from '../../configs/serverPath';
import productsList from './productsList';
import useCurrentPlatformUMStatus from '../../hooks/useCurrentPlatformUMStatus';

const Products = () => {
    const { t } = useTranslation();
    const { composePath } = useSiteInfo();
    const [state, dispatch] = useContext(HeaderContext);
    useEffect(() => {
        delCookie('_EPoint');
    }, []);
    const { fetchCurrentPlatUMData } = useCurrentPlatformUMStatus();
    const handleProductLogin = async (enterPoint) => {
        const isCurrentPlatformUM = await fetchCurrentPlatUMData();
        if (isCurrentPlatformUM) {
            dispatch({ type: 'SHOW_UM_POPUP' });
        } else {
            dispatch({ type: 'SHOW_LOGIN_POPUP' });
            dispatch({ type: 'UPDATE_LOGIN_ENTER_POINT', value: enterPoint });
            setCookie('_EPoint', enterPoint, 365);
        }
    };

    return (
        <div className="product-sports" data-open="true">
            <div className="sports-list">
                {
                    productsList.map(({ title, enterPoint, imagePath }) => (
                        <div
                            className="sports-card"
                            onClick={
                                () => { handleProductLogin(enterPoint); }
                            }
                        >
                            <div className="sports-card__title">
                                <span className="text">{t(title)}</span>
                            </div>
                            <div className="sports-card__image">
                                <img
                                    src={composePath({ pathType: ServerPath.siteImage, pathName: imagePath })}
                                    alt=""
                                />
                            </div>
                        </div>
                    ))
                }

            </div>
        </div>
    );
};

export default Products;
